import React from 'react';
import completeProfile from '../../../../assets/images/savings_optin_success.png'
import kudzuPluseLogo from '../../../../assets/kudzu-plus-images/KudzuPluseLogo.png'
import SmiOneCard from '../../../../assets/smi-kudzu-images/smi_card_success.png'
//savings_optin_successpng.png
import { useTranslation } from "react-i18next";
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const SmiOneRegistrationSuccessModal = ({handleDone}) => {
  const navigate = useNavigate();
    

    const { t } = useTranslation();
    return (
        <>
        <div className='flex flex-col justify-center items-center w-full'>
        <p className='font-hanken-grotesk lg:text-[19px] md:text-[17px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
        md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{t("as_a_kudzu_user")}</p>

        <img src={SmiOneCard} alt="complete" className=' md:w-[270px]  sm:w-[92px]   md:my-10 sm:my-10 my-8' />
        <div className='flex flex-col justify-center items-center w-full'>

        <div className=' flex flex-col justify-center items-center gap-8 w-full'>
        <button className="focus:outline-none   bg-[#2965FB] text-[16px] w-full 
        text-[#fff] font-[600] h-[60px] border-2 border-[#2965FB]" onClick={handleDone}>
              {/* {t('home')}  */}
              {t('Home')} 
            </button>
        </div>
        </div>

        </div>
        
        </>
    )
}

export default SmiOneRegistrationSuccessModal;